import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    const handleTermsClick = () => {
        // Add navigation logic or modal opening logic here
        console.log('Terms & Conditions clicked');
    };

    const handlePrivacyClick = () => {
        // Add navigation logic or modal opening logic here
        console.log('Privacy Policy clicked');
    };

    const handleContactClick = () => {
        // Add navigation logic or modal opening logic here
        console.log('Contact Us clicked');
    };

    return (
        <footer className="site-footer">
            <div className="footer-content">
                <div className="copyright">
                    <p>&copy; {new Date().getFullYear()} RewardRedeemer. All rights reserved.</p>
                </div>
                <div className="footer-links">
                    <button type="button" className="footer-link-button" onClick={handleTermsClick}>Terms</button>
                    <button type="button" className="footer-link-button" onClick={handlePrivacyClick}>Privacy</button>
                    <button type="button" className="footer-link-button" onClick={handleContactClick}>Contact</button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;